import api from '@/helpers/api_helper';
import { apiUrls } from '@/constant/configure';
import type {
    CreateDmAutomationReq,
    DmAutomationDto,
    DmAutomationStatsDto,
    DmSendLogPage,
    StatsOverviewDto,
    StatsPeriod,
    UpdateDmAutomationReq,
} from '@/types/dmAutomation';

const studio = { baseURL: apiUrls.studio };
const PREFIX = '/api/v1';

export const getAutomations = async (): Promise<DmAutomationDto[]> => {
    const res = await api.get<{ itemList: DmAutomationDto[] }>(`${PREFIX}/automations`, studio);
    return res.data.itemList;
};

export const createAutomation = async (body: CreateDmAutomationReq): Promise<void> => {
    await api.post(`${PREFIX}/automations`, body, studio);
};

export const updateAutomation = async (id: string, body: UpdateDmAutomationReq): Promise<void> => {
    await api.put(`${PREFIX}/automations/${id}`, body, studio);
};

export const toggleAutomation = async (id: string, isActive: boolean): Promise<void> => {
    await api.patch(`${PREFIX}/automations/${id}/toggle`, { isActive }, studio);
};

export const deleteAutomation = async (id: string): Promise<void> => {
    await api.delete(`${PREFIX}/automations/${id}`, studio);
};

export const getStatsOverview = async (): Promise<StatsOverviewDto> => {
    const res = await api.get<{ item: StatsOverviewDto }>(`${PREFIX}/automations/stats/overview`, studio);
    return res.data.item;
};

export const getAutomationStats = async (
    id: string,
    period: StatsPeriod = 'all',
): Promise<DmAutomationStatsDto> => {
    const res = await api.get<{ item: DmAutomationStatsDto }>(`${PREFIX}/automations/${id}/stats`, {
        ...studio,
        params: { period },
    });
    return res.data.item;
};

export const getAutomationLogs = async (
    id: string,
    page = 1,
    limit = 20,
): Promise<DmSendLogPage> => {
    const res = await api.get<DmSendLogPage>(`${PREFIX}/automations/${id}/logs`, {
        ...studio,
        params: { page, limit },
    });
    return res.data;
};
